import React, {useLayoutEffect, useRef} from "react";
import SquareSloth from "../assets/sloth/square_sloth.png";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Sloth1 from "../assets/sloth-cards/sloth_card_1.png";
import Sloth2 from "../assets/sloth-cards/sloth_card_2.png";
import Sloth3 from "../assets/sloth-cards/sloth_card_3.png";
import Sloth4 from "../assets/sloth-cards/sloth_card_4.png";


const SlothImages = [
  Sloth1,
  Sloth2,
  Sloth3,
  Sloth4
]

const Row = (props) => {
  return (
    <>
      {Array(props.length)
        .fill(0)
        .map((_, i) => {

          const slothIndex = i % SlothImages.length;

          return (
            <div key={i}>
              <img
                src={SlothImages[slothIndex]}
                className="min-w-[151px] h-[151px] lg:min-w-[25vw] lg:h-[25vw] aspect-square"
              />
            </div>
          );
        })}
    </>
  );
};

const SlothSlider = (props) => {
  gsap.registerPlugin(ScrollTrigger);
  const ref = useRef(null);

  useLayoutEffect(() => {
    const tl = gsap.timeline({
        ease: "power3.inOut",
      scrollTrigger: {
        trigger: ref.current,
        scrub: true,
        end: "+=" + window.innerHeight * 3,

      },
    });

    tl.fromTo(
      ".tl-top",
      {
        x: "-50%",
      },
      {
        x: "0%",
        duration: 2.5,
      },
      "0"
    );

    tl.fromTo(
      ".tl-bottom",
      {
        x: "0%",
      },
      {
        x: "-50%",
        duration: 2.5,
      },
      "0"
    );
  }, []);

  return (
    <section className="pt-[95px] pb-[60px] lg:py-[90px] relative space-y-[15px] lg:space-y-[40px]" ref={ref}>
      <div className="flex flex-nowrap flex-row space-x-[12px] lg:space-x-[30px] tl-bottom">
        <Row length={10} />
      </div>
      <div className="flex flex-nowrap flex-row space-x-[12px] lg:space-x-[30px] tl-top">
        <Row length={10} />
      </div>
    </section>
  );
};

export default SlothSlider;
